import gql from 'graphql-tag';
import { OrderListItem } from '../fragments';
import PaginatorInfoFragment from '../fragments/PaginatorInfoFragment';

export default gql`
query Orders(
    $filters: OrderFilters
    $sortBy: OrderSort
    $count: Int!
    $page: Int
) {
    orders(
        filters: $filters
        sortBy: $sortBy
        first: $count
        page: $page
    ) {
        paginatorInfo {
            ...PaginatorInfoFragment
        }
        data {
            ...OrderListItem
        }
    }
}
${PaginatorInfoFragment}
${OrderListItem}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/orders.ts